import React, { Component } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

export class Tooltip extends Component {
  static displayName = 'Tooltip'

  static propTypes = {
    theme: PropTypes.oneOf(['dark', null]),
    triggerText: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
      .isRequired,
    containerClass: PropTypes.string,
    contentWidth: PropTypes.number,
    children: PropTypes.node,
  }

  static defaultProps = {
    contentWidth: 280,
  }

  state = {
    isVisible: false,
  }

  closeListenerIsActive = false

  toggleTooltip = () => {
    this.setState(
      (prevState) => {
        return {
          isVisible: !prevState.isVisible,
        }
      },
      () => this.setCloseEventListener()
    )
  }

  setCloseEventListener = () => {
    if (this.state.isVisible && !this.closeListenerIsActive) {
      document.addEventListener('touchend', this.handleDocumentTouchEnd)
      this.closeListenerIsActive = true
    }
  }

  handleDocumentTouchEnd = () => {
    this.hideTooltip()
    document.removeEventListener('touchend', this.handleDocumentTouchEnd)
    this.closeListenerIsActive = false
  }

  hideTooltip = () => {
    this.setState({
      isVisible: false,
    })
  }

  render() {
    const {
      className,
      theme,
      triggerText,
      containerClass,
      contentWidth,
      children,
    } = this.props

    return (
      <div
        className={classnames('tooltip', className, containerClass, {
          'tooltip--dark': theme === 'dark',
        })}
      >
        <span
          className={classnames('tooltip__trigger', {
            'tooltip__trigger--active': this.state.isVisible,
          })}
          onTouchEnd={this.toggleTooltip}
        >
          <span className="tooltip__trigger__text">{triggerText}</span>

          <div
            className="tooltip__content"
            style={{ width: `${contentWidth}px` }}
          >
            {children}
          </div>
        </span>
      </div>
    )
  }
}

export default Tooltip
